<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card
              class="elevation-2"
          >
              <v-toolbar
                  style="background:linear-gradient(135deg, #17ead9 0%,#6078ea 100%)">
                <v-toolbar-title class="white--text mt-4 mb-4">
                  Active Numbers
                </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn outlined router :to="'/getNewPhoneNumber'" class="white--text">
                   <v-icon>add</v-icon> Add a Number
                  </v-btn>
              </v-toolbar>
            <v-card-text v-if="provisionedPhoneNumbers">
              <v-simple-table v-if="provisionedPhoneNumbers.length !== 0">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Friendly Name
                    </th>
                    <th class="text-left">
                      Phone Number
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in provisionedPhoneNumbers"
                      :key="item.phoneNumber"
                      @click="goToNumberDash(item)"
                  >
                    <td>{{ item.friendlyName }}</td>
                    <td>{{formatPhoneNumber(item.phoneNumber) }}</td>
                    <td v-if="item.status.type === 'active'"><v-icon class="success--text">fiber_manual_record</v-icon></td>
                    <td v-if="item.status.type === 'error'"><v-icon class="error--text">fiber_manual_record</v-icon></td>
                    <td v-if="item.status.type === 'warning'"><v-icon class="warning--text">fiber_manual_record</v-icon></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div v-else class="">
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      No active numbers. Add a number to continue.
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <div class="pl-3 pb-2">
                  <h2 class="font-weight-bold">Standard Plan</h2>
                  <v-divider ></v-divider>
                </div>


                <div v-if="subscription" class="mb-3">
                  <ul v-for="feature in subscription.features" :key="feature">
                    <h3 class="font-weight-regular pb-3">
                      <v-icon>check</v-icon>
                      {{feature}}
                    </h3>
                  </ul>
                  <div v-if="subscription" class="pl-3">
                    <h2 class="font-weight-bold">Pricing</h2>
                    <v-divider></v-divider>
                    <h3 class="font-weight-regular pt-2 mb-1">Phone Number: ${{subscription.rates.costPerNumber}} /month</h3>
                    <h3 class="font-weight-regular mb-1">Calls: ${{subscription.rates.costPerCall}} /min</h3>
                    <h3 class="font-weight-regular mb-1">Texts: ${{subscription.rates.costPerSMS}} /text</h3>
                  </div>
                  <v-btn outlined router :to="'/getNewPhoneNumber'" class="mt-3 blue--text">
                    <v-icon>add</v-icon> Add a Number
                  </v-btn>
                </div>

                <div v-else>

                  No active numbers. Add a number to continue.
                </div>
              </div>
            </v-card-text>
            <app-loading class="pa-12" v-else></app-loading>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="newNumberDialog"
              ref="dialog"
              persistent
              width="290px"
    >
      <v-card
          class="mx-auto"
          max-width="500"
      >
        <v-card-title class="text-h6 font-weight-regular justify-space-between">
          <div class="white black--text text-xs-center font-weight-thin headline">{{ selectedNumberMessage }}</div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="newNumberDialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import { collection, getDocs} from "firebase/firestore";
export default {
  data: () => ({
    provisionedPhoneNumbers: null,
    newNumberDialog: false,
    selectedNumberMessage: ''
  }),
  computed: {
    subscription () {
      let subs = this.$store.getters.subscriptions
      let phonePlan = null
      // console.log(subs)
      subs.forEach(sub => {
        if (sub.id === 'flexlinePhoneNumber') {
          // console.log(sub)
          phonePlan = sub
        }
      })
      return phonePlan
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    let db = this.$store.state.db
    let numbersRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers'))
    return numbersRef
    .then (numbers => {
      let numbersList = []
        numbers.forEach (number => {
        numbersList.push(number.data())
      })
      this.provisionedPhoneNumbers = numbersList
    })
  },
  methods: {
    formatPhoneNumber(phoneNumberString) {
      // console.log(phoneNumberString)
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    },
    goToNumberDash(selectedNumber) {
      //console.log(selectedNumber)
      if(selectedNumber.status.type !== 'active'){
        this.newNumberDialog = true
        this.selectedNumberMessage = selectedNumber.status.message
      } else {
        this.$router.push('/numberPortal/' + selectedNumber.phoneNumber)
      }

    }
  }
}
</script>
